import { useAptabase } from "@aptabase/react";
import { S3Image } from "../../../components/S3Image";
import { ISponsor } from "../../../api/client/Api";
import { addUTMParams } from "../../../utils/url";

interface SponsorsBarProps {
  sponsors?: ISponsor[];
}

const SponsorsBar = ({ sponsors }: SponsorsBarProps) => {
  const { trackEvent } = useAptabase();

  const onClickPartner = (partner: string) => {
    trackEvent("click", { screenName: "landing_page", partner });
  };

  return (
    <div className="bg-indigo-50">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <p className="text-base text-green-600 font-semibold tracking-wide uppercase">
            Partenaires
          </p>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-4 mt-2 items-center justify-items-center">
            {sponsors?.map((sponsor, index) => (
              <a
                key={index.toString()}
                href={addUTMParams(
                  sponsor.website,
                  "tournoi-co",
                  "sponsor",
                  "landing-page"
                )}
                target="_blank"
                rel="noreferrer"
                onClick={() => onClickPartner(sponsor.name)}
                className="flex items-center justify-center w-full h-24"
              >
                <S3Image
                  keyPath={sponsor.logo_key}
                  alt={sponsor.name}
                  className="h-24 w-auto object-contain bg-white max-w-full"
                  fallbackSrc="/assets/sponsor-placeholder.png"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorsBar;
